
export const ReportsPresentation = () => {
    return (
        <div>
            <h1>Report Analysis</h1>
        </div>
    )
};